module.exports = __webpack_public_path__ + "media/images/top/seminars/template/image04-efe3e6fe4d5eb46a593ba23714e6b0b6.jpeg";